import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'valueAsArray',
})
export class ValueAsArrayPipe implements PipeTransform {
    transform(value: any): any[] {
        return !value || Array.isArray(value) ? value : [value];
    }
}
